import { Messages } from '../../../codegen/Localize';
import { Order } from '../../../ts/helpers/Order';
import { OrderKeys } from '../../../ts/models/OrderKeys';
import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';

export const DataSourceSubspaceWorkbookSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'hits': SortOptions.hits,
  'sheets': {
    id: 'sheets',
    getMenuItemDisplayValue: Messages.column_numSheets,
    subSortOptions: {
      'desc': {
        id: 'sheets.desc',
        field: OrderKeys.numSheets,
        getMenuItemDisplayValue: Messages.sortByMostLeast,
        getButtonDisplayValue: Messages.sortByNumSheetsDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.numSheets), Order.asc(OrderKeys.name)]
      },
      'asc': {
        id: 'sheets.asc',
        field: OrderKeys.numSheets,
        getMenuItemDisplayValue: Messages.sortByLeastMost,
        getButtonDisplayValue: Messages.sortByNumSheetsAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.numSheets), Order.asc(OrderKeys.name)]
      }
    }
  },
  'size': {
    id: 'size',
    getMenuItemDisplayValue: Messages.column_size,
    subSortOptions: {
      'desc': {
        id: 'size.desc',
        field: OrderKeys.size,
        getMenuItemDisplayValue: Messages.sortByLargeSmall,
        getButtonDisplayValue: Messages.sortBySizeDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.size)]
      },
      'asc': {
        id: 'size.asc',
        field: OrderKeys.size,
        getMenuItemDisplayValue: Messages.sortBySmallLarge,
        getButtonDisplayValue: Messages.sortBySizeAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.size)]
      }
    }
  },
  'containerName': SortOptions.containerName,
  'owner': SortOptions.owner,
  'updated': SortOptions.updated,
  'modifiedBy': SortOptions.modifiedBy,
  'alert': SortOptions.alert
};

export const workbookSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  ...DataSourceSubspaceWorkbookSortOptions
};
